module.exports = __webpack_public_path__ + "img/plantilla.57694a0b.png";